import { AlertTriangle } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAdminAccess } from "@/hooks/useAdminAccess";
import { cn } from "@/lib/utils";

interface SidebarHealthStripProps {
  collapsed: boolean;
}

export function SidebarHealthStrip({ collapsed }: SidebarHealthStripProps) {
  const { t } = useTranslation("admin");
  const navigate = useNavigate();
  const { isError } = useAdminAccess();

  if (!isError) return null;

  return (
    <button
      onClick={() => navigate("/health")}
      className={cn(
        "mx-2 mb-2 flex items-center gap-2 rounded-lg border transition-colors",
        "border-red-500/20 bg-red-500/5 hover:bg-red-500/10",
        "dark:border-red-500/30 dark:bg-red-500/10 dark:hover:bg-red-500/15",
        collapsed ? "justify-center p-2" : "px-3 py-2",
      )}
      title={collapsed ? t("errors.server") : undefined}
    >
      <AlertTriangle className="h-4 w-4 text-red-500 shrink-0" />
      {!collapsed && (
        <span className="text-xs font-medium text-red-600 dark:text-red-300 truncate">
          {t("errors.server")}
        </span>
      )}
    </button>
  );
}
